module.exports = __webpack_public_path__ + "9ede86e9a4bc062655d63c80f9d71d46.svg";